import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import withStyles from 'react-jss';
import ReactPlayer from 'react-player';
import i18n from 'i18next';
import { Translation, Trans } from 'react-i18next';
import CampusBackground from './CampusBackground';
import { getAuthState } from '../store/selectors';
import { setUser, setAuthStatus } from '../store/actions';
import { loginCopy } from '../copy/loginCopy.json';
import RouteBack from './utility/RouteBack';
import SchoolLogo from './utility/SchoolLogo';
import CancelIcon from './utility/CancelIcon';
import RIASECCompass from '../ASUPhotos/RIASEC_Compass_v3.png';
import AudioDescriptionsIcon from '../ASUPhotos/icons/audioDescriptions.gif';
import Me3Video from '../videos/me3-V2 [English].mp4';
import Me3VideoAudioDescriptions from '../videos/me3-V2 [English][AD].mp4';
import Me3VideoSubtitles from '../videos/me3-V2 [English].vtt';
import { fireGTM } from '../gtm/gtmUtil';
import {
  closeCross_GTM,
  playNow_GTM,
} from '../gtm/datalayers/utilDataLayers.json';

const me3Email = 'me3@asu.edu';

const introButtonStyles = {
  color: (props) => ({
    backgroundColor: props.tenant.primary,
    color: 'white',

    '&:hover': {
      backgroundColor: 'white',
      border: `2px solid ${props.tenant.primary}`,
      color: props.tenant.primary,
      borderStyle: 'solid',
    },
  }),
};

class Intro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showVid: false,
      history: this.props.history,
      left: '95%',
      top: '3%',
      audioDescriptionsOn: false,
    };
    this.videoRef = React.createRef();
    this.wholePageRef = React.createRef();
    this.startPlaying = this.startPlaying.bind(this);
    this.introVideo = this.introVideo.bind(this);
  }

  cancelBorder = {
    border: `2px solid ${this.props.tenant.primary}`,
  };

  componentDidMount() {
    if (this.props.location.search === '?video=true') {
      this.setState({ showVid: true });
    }

    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.top === '3%') this.calculateCancelContainer();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  }

  onWindowResize = () => {
    this.calculateCancelContainer();
  };

  startPlaying() {
    this.props.history.push('onboarding/education');
  }

  onKeyPressed(event) {
    if (event.keyCode === 27) {
      this.state.history.goBack();
    }
  }

  handleCloseVideo = () => {
    fireGTM(closeCross_GTM, 'close cross', 'introduction video');
    this.state.history.goBack();
  };

  // magic number that is half the pixel size of the cancel button
  halfCancelButtonSize = 21;

  calculateCancelContainer = () => {
    let left;
    let top;

    if (this.videoRef.current) {
      if (this.wholePageRef.current.clientWidth <= 800) {
        if (this.state.left !== '90%') {
          this.setState({
            left: '92%',
          });
        }

        if (this.state.top !== '1%') {
          this.setState({
            top: '1%',
          });
        }

        return;
      }

      if (this.wholePageRef.current.clientWidth <= 1025) {
        if (this.state.left !== '95%') {
          this.setState({
            left: '95%',
          });
        }

        if (this.state.top !== '3%') {
          this.setState({
            top: '3%',
          });
        }

        return;
      }

      const leftoverSpace =
        (this.wholePageRef.current.clientWidth -
          this.videoRef.current.clientWidth) /
        2;

      left = `${
        this.videoRef.current.clientWidth +
        leftoverSpace -
        this.halfCancelButtonSize
      }px`;

      const leftOverTopSpace =
        (this.wholePageRef.current.clientHeight -
          this.videoRef.current.clientHeight) /
        2;

      top = `${leftOverTopSpace - this.halfCancelButtonSize}px`;
    }

    this.setState({
      left,
      top,
    });
  };

  toggleADVideo = () => {
    const introPlayer =
      document.getElementsByClassName('intro-player')[0].firstChild;
    const subtitlesTrack = introPlayer.firstChild;

    if (!this.state.audioDescriptionsOn) {
      introPlayer.src = Me3VideoAudioDescriptions;
      introPlayer.autoplay = true;
      subtitlesTrack.src = null;
    } else {
      introPlayer.src = Me3Video;
      introPlayer.autoplay = true;
      subtitlesTrack.default = Me3VideoSubtitles;
    }

    this.setState((prevState) => ({
      audioDescriptionsOn: !prevState.audioDescriptionsOn,
    }));
  };

  introVideo(t) {
    return (
      <div className="video-modal">
        <h1 style={{ display: 'none' }}>me3 Video Introduction</h1>
        <div
          className="cancel-container"
          tabIndex={0}
          onClick={this.handleCloseVideo}
          onKeyDown={(e) => this.onKeyPressed(e)}
          role="button"
          style={{ left: this.state.left, top: this.state.top }}
          aria-label="close video and return to landing page"
        >
          <CancelIcon color={this.props.tenant.primary} />
        </div>
        <ReactPlayer
          controls
          className="intro-player"
          url={Me3Video}
          config={{
            file: {
              tracks: [
                {
                  kind: 'subtitles',
                  src: Me3VideoSubtitles,
                  srcLang: 'en',
                  label: 'English',
                  default: true,
                },
              ],
            },
          }}
        />
        <div
          className="audio-descriptions-button"
          tabIndex={0}
          role="button"
          onClick={this.toggleADVideo}
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) this.toggleADVideo();
          }}
        >
          <img
            src={AudioDescriptionsIcon}
            alt="Audio Description icon."
            width="30px"
            height="30px"
          />
          <p className="audio-descriptions-button__text">
            {this.state.audioDescriptionsOn
              ? t('Click to turn off audio description')
              : t('Click to turn on audio description')}
          </p>
        </div>
      </div>
    );
  }

  secondaryBackground = {
    backgroundColor: `${this.props.tenant.secondary}`,
  };

  secondaryBorderLarge = {
    borderTop: `11px solid ${this.props.tenant.secondary}`,
  };

  primaryColor = {
    color: `${this.props.tenant.primary}`,
  };

  primaryBackground = {
    backgroundColor: `${this.props.tenant.primary}`,
  };

  primaryColorOutlined = {
    color: `${this.props.tenant.primary}`,
    border: `1px solid ${this.props.tenant.primary}`,
  };

  get me3IntroParagraphOne() {
    return i18n.t(
      '{{appName}}® is a simple interactive tool that helps you find a career that fits your interests. {{appName}} guides you through a series of visual choices that reflect your levels of interest in data, things, people and ideas. {{appName}} then provides matches that best fit your interests and corresponding career options. Each career option displays a list of associated education opportunities. You can even rank careers in your order of preference.',
      { appName: 'me3' }
    );
  }

  get me3IntroParagraphTwo() {
    return i18n.t(
      '{{appName}} uses the {{modelType}} model, a career interest model that has more empirical support than any other career theory. It was developed to narrow the gap between uncertainty and career paths. Closing this gap has been linked to greater career stability and job satisfaction, and an overall better college experience for students.',
      { appName: 'me3', modelType: 'RIASEC' }
    );
  }

  get me3IntroParagraphThree() {
    return i18n.t(
      '{{appName}} helps you explore careers that are aligned to your interests. It also compares career outlooks and average salaries, and charts academic pathways.',
      { appName: 'me3' }
    );
  }

  get me3ScienceParagraph() {
    return i18n.t(
      '{{appName}} technology creates a {{modelName}}-based career interest profile based on the images you like most. Your {{modelName}} interests are mapped to hundreds of careers. {{appName}} career matches utilize data provided by the U.S. Department of Labor. {{appName}} mapping technology then connects careers to educational offerings which allow you to prepare for your dream career. ',
      { appName: 'me3', modelName: 'RIASEC' }
    );
  }

  get reachOutPrompt() {
    return i18n.t(
      'Reach out to the {{appName}} team to learn about licensing and partnership opportunities and how to make {{appName}} yours.',
      { appName: 'me3' }
    );
  }

  get licensingBulletStrings() {
    return {
      institutions: {
        subheading: i18n.t('Educational institutions: '),
        bullet: i18n.t(
          'Licensing agreements are available to map custom educational offerings to your own institution’s version of {{appName}}.',
          { appName: 'me3' }
        ),
      },
      secondaryEd: {
        subheading: i18n.t(
          'Secondary education (high schools or school districts): '
        ),
        bullet: i18n.t(
          'Offer students robust career and education exploration tools with built-in advisor dashboard support.'
        ),
      },
      organizations: {
        subheading: i18n.t('Organizations: '),
        bullet: i18n.t(
          'Partner with {{appName}} to support employees and help them learn about educational opportunities.',
          { appName: 'me3' }
        ),
      },
    };
  }

  render() {
    const { showVid } = this.state;

    if (showVid) {
      return (
        <Translation>
          {(t) => (
            <CampusBackground
              secondaryColor={this.props.tenant.secondary}
              optRef={this.wholePageRef}
            >
              <div className="intro-vid-container" ref={this.videoRef}>
                {this.introVideo(t)}
              </div>
            </CampusBackground>
          )}
        </Translation>
      );
    }

    /* eslint-disable react/jsx-one-expression-per-line */
    /* Note: the above eslint-disable is necessary as the interpolation within <Trans> components is wrongly interpreted as JSX */
    return (
      <Translation>
        {(t) => (
          <div className="intro-page">
            <div
              className="intro-page-container"
              style={this.secondaryBorderLarge}
            >
              <div className="top-container">
                <div className="top-left">
                  <div className="routing-container">
                    <RouteBack
                      color={this.props.tenant.primary}
                      route="/landing"
                      tenant={this.props.tenant}
                      section="read introduction"
                      text="back"
                    />
                  </div>
                  <div className="asu-logo-container-intro">
                    <SchoolLogo
                      schoolLogoWidth="75%"
                      horizontalAlign="flex-start"
                      schoolLogoContainerWidth="100%"
                    />
                  </div>
                  <div className="how-to-container">
                    <h1
                      className="how-to-text"
                      style={this.secondaryBackground}
                    >
                      {t('How to use {{appName}}', { appName: 'me3' })}
                    </h1>
                  </div>
                </div>
                <div className="top-right">
                  <div className="intro-campus-img-container">
                    <img
                      className="intro-campus-img"
                      src={this.props.tenant.hero}
                      alt={t('campus')}
                    />
                  </div>
                </div>
              </div>
              <div className="bottom-container">
                <div className="intro-text-container">
                  <h2 className="intro-header-text" style={this.primaryColor}>
                    {t('Explore your interests, envision your future')}
                  </h2>
                  <p className="intro-paragraph">{this.me3IntroParagraphOne}</p>
                  <br />
                  <p className="intro-paragraph">{this.me3IntroParagraphTwo}</p>
                  <br />
                  <h2 className="intro-header-text" style={this.primaryColor}>
                    {t('What {{appName}} offers', { appName: 'me3' })}
                  </h2>
                  <p className="intro-paragraph">
                    {this.me3IntroParagraphThree}
                  </p>
                </div>
                <br />
                <h2 className="intro-header-text" style={this.primaryColor}>
                  {t('{{codesType}} codes and corresponding interest types', {
                    codesType: 'RIASEC',
                  })}
                </h2>
                <p className="intro-paragraph">
                  {t('What do {{codesType}} codes say about your interests?', {
                    codesType: 'RIASEC',
                  })}
                </p>
                <div className="bullets-container">
                  <span className="intro-paragraph bullet">
                    {loginCopy.bullet1}
                  </span>
                  <br />

                  <span className="intro-paragraph bullet">
                    {loginCopy.bullet2}
                  </span>
                  <br />

                  <span className="intro-paragraph bullet">
                    {loginCopy.bullet3}
                  </span>
                  <br />

                  <span className="intro-paragraph bullet">
                    {loginCopy.bullet4}
                  </span>
                  <br />

                  <span className="intro-paragraph bullet">
                    {loginCopy.bullet5}
                  </span>
                  <br />

                  <span className="intro-paragraph bullet">
                    {loginCopy.bullet6}
                  </span>
                  <br />
                </div>
                <br />
                <p className="intro-paragraph">
                  <a
                    rel="noreferrer noopener"
                    target="_blank"
                    href="https://me3.careers"
                  >
                    {t(
                      'Learn more about {{interestTypeCategory}} interest types.',
                      {
                        interestTypeCategory: 'RIASEC',
                      }
                    )}
                  </a>
                </p>
                <img
                  alt="riasec diagram"
                  src={RIASECCompass}
                  className="riasec-diagram"
                />
                <br />
                <br />
                <h2 className="intro-header-text" style={this.primaryColor}>
                  {t('The science behind {{appName}}', { appName: 'me3' })}
                </h2>
                <p className="intro-paragraph">{this.me3ScienceParagraph}</p>
                <br />
                <p className="intro-paragraph">
                  <a
                    rel="noreferrer noopener"
                    target="_blank"
                    href="https://eadvisor.asu.edu/me3ASU"
                  >
                    {t('Learn more about this research.')}
                  </a>
                </p>
                <br />
                <h2 className="intro-header-text" style={this.primaryColor}>
                  {t('Licensing opportunites')}
                </h2>
                <p className="intro-paragraph">
                  <Trans>
                    Reach out to the {{ appName: 'me3' }} team to learn about
                    licensing and partnership opportunities and how to make{' '}
                    {{ appName: 'me3' }} yours. Email{' '}
                    <a href={`mailto:${me3Email}`}>
                      {{ emailAddress: me3Email }}
                    </a>{' '}
                    for details.
                  </Trans>
                </p>
                <br />
                <p className="intro-paragraph" style={this.primaryColor} />
                <div className="bullets-container">
                  <svg height="10" width="10" role="img">
                    <title>
                      {this.licensingBulletStrings.institutions.subheader}
                    </title>
                    <circle cx="5" cy="5" r="4" fill="#FFC626" />
                  </svg>
                  <span className="intro-paragraph bullet bold">
                    {this.licensingBulletStrings.institutions.subheader}
                  </span>
                  <span className="intro-paragraph">
                    {this.licensingBulletStrings.institutions.bullet}
                  </span>
                  <br />
                  <svg height="10" width="10" role="img">
                    <title>
                      {this.licensingBulletStrings.secondaryEd.subheader}
                    </title>
                    <circle cx="5" cy="5" r="4" fill="#FFC626" />
                  </svg>
                  <span className="intro-paragraph bullet bold">
                    {this.licensingBulletStrings.secondaryEd.subheader}
                  </span>
                  <span className="intro-paragraph">
                    {this.licensingBulletStrings.secondaryEd.bullet}
                  </span>
                  <br />
                  <svg height="10" width="10" role="img">
                    <title>
                      {this.licensingBulletStrings.organizations.subheader}
                    </title>
                    <circle cx="5" cy="5" r="4" fill="#FFC626" />
                  </svg>
                  <span className="intro-paragraph bullet bold">
                    {this.licensingBulletStrings.organizations.subheader}
                  </span>
                  <span className="intro-paragraph">
                    {this.licensingBulletStrings.organizations.bullet}
                  </span>
                </div>
                <br />
                <h2 className="intro-header-text" style={this.primaryColor}>
                  {t('Contact us')}
                </h2>
                <p className="intro-paragraph">
                  <Trans>
                    Got questions? Email us at{' '}
                    <a href={`mailto:${me3Email}`}>
                      {{ emailAddress: me3Email }}
                    </a>
                    .
                  </Trans>
                </p>
                <div className="play-button-container">
                  <Link to="onboarding/education">
                    <button
                      type="button"
                      onClick={() =>
                        fireGTM(
                          playNow_GTM,
                          'start playing me3',
                          'read introduction'
                        )
                      }
                      className={[
                        'me3-button',
                        'button--primary',
                        'start-playing',
                        this.props.classes.color,
                      ].join(' ')}
                    >
                      {t('Start playing {{appName}}', { appName: 'me3' })}
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const auth = getAuthState(state);

  return { auth };
};

const IntroWithRouter = withRouter(
  connect(mapStateToProps, { setAuthStatus, setUser })(Intro)
);

export default withStyles(introButtonStyles)(IntroWithRouter);
